import { MatchData } from '@/interfaces/liveGamesType';

export interface League {
  id: string;
  name: string;
  country: string;
  logo: string;
}

export interface GroupedMatches {
  [key: string]: {
    league: string;
    country: string;
    matches: MatchData[];
  }
}

export interface MatchStats {
  home_team: string;
  away_team: string;
  statistics: Array<{
    type: string;
    home: string;
    away: string;
  }>;
}

export enum TabType {
  ALL = 0,
  LIVE = 1,
  FINISHED = 2,
  FAVORITES = 3
}

export interface DashboardState {
  date: Date;
  loading: boolean;
  tabValue: TabType;
  leagues: League[];
  liveMatches: MatchData[];
  finishedMatches: MatchData[];
  selectedMatch: MatchData | null;
  favorites: string[];
  searchQuery: string;
  openDetailsMobile: boolean;
}